import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'wsb-grid-html-renderer',
  template: `
    <div *ngIf="content" [innerHTML]="content"></div>
  `,
  standalone: false
})
export class AtlasGridHtmlRendererComponent implements ICellRendererAngularComp {
  params;
  content: SafeHtml;

  constructor() {}

  agInit(params): void {
    this.params = params;
    this.content = this.params.content ? this.params.content(params) : null;
    if (this.params.contentObservable) {
      this.params.contentObservable(params).subscribe(x => (this.content = x));
    }
  }

  refresh(params: any): boolean {
    return false;
  }
}
